import { Mui, MuiX } from "@osu/react-ui";
import { useGetReviewersQuery } from '../../services/graphql/api';

export default function ReviewerList({ addTab, showReviewers }) {
    const { isFetching, data } = useGetReviewersQuery({ isActive: true }, { refetchOnMountOrArgChange: true });
    if (!showReviewers) { return <></>; }

    const getColumnDefinitions = data?.columns?.map((col) => {
        if (col.field === 'name') {
            return {
                ...col,
                renderCell: (params) => (
                    <Mui.Link
                        component="button"
                        variant="body2"
                        onClick={() => addTab(params.row.id, params.row.name)}
                        key={params.row.id}
                    >
                        {params.value}
                    </Mui.Link>
                ),
            };
        }
        return col;
    }) ?? [{ field: "", flex: 1 }]; // Default is necessary to show loading indicator; field prop necessary to prevent unique key error log
    
    const rows = data?.reviewers?.map(reviewer => ({
        ...reviewer,
        lastAssignedDate: new Date(reviewer.lastAssignedDate).toLocaleDateString(),
    })) ?? [{ id: "1" }]; // Default is necessary to show loading indicator
    
    return (
        <MuiX.DataGrid
            autoHeight={true}
            columns={getColumnDefinitions}
            disableSelectionOnClick
            isRowSelectable={() => false}
            rows={rows}
            loading={isFetching}
            slotProps={{ loadingOverlay: { variant: "linear-progress" } }}
        /> 
    );
}